import { QuestionCircleOutlined } from '@ant-design/icons';
import { Card, Descriptions, Form, Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';

import { FormInputRelativeDate } from './form-input-relative-date';
import { requiredRules, useErrorFieldsStatusContext } from './form-utils';

export const TicketsCard = observer(() => {
  const errorFieldsStatus = useErrorFieldsStatusContext();

  return (
    <Card size="small" title="Билеты">
      <Descriptions bordered size="small" column={1}>
        <Descriptions.Item
          label={
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <span>Старт продаж</span>
              <Tooltip title="Целое отрицательное число">
                <QuestionCircleOutlined />
              </Tooltip>
            </div>
          }
          labelStyle={{ width: '1%', whiteSpace: 'nowrap' }}
        >
          <Form.Item
            name="salesStartDelay"
            rules={requiredRules}
            noStyle={true}
          >
            <FormInputRelativeDate
              relativeDateFieldName="startTime"
              withDuration
              status={errorFieldsStatus.getFieldStatus('salesStartDelay')}
            />
          </Form.Item>
        </Descriptions.Item>
        <Descriptions.Item
          label={
            <div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <span>Закрытие продаж</span>
                <Tooltip title="Целое отрицательное число">
                  <QuestionCircleOutlined />
                </Tooltip>
              </div>
              <div>
                <small>Количество минут до начала отправления</small>
              </div>
            </div>
          }
          labelStyle={{
            width: '1%',
            whiteSpace: 'nowrap',
          }}
        >
          <Form.Item name="salesStopDelay" noStyle={true} rules={requiredRules}>
            <FormInputRelativeDate
              relativeDateFieldName="startTime"
              status={errorFieldsStatus.getFieldStatus('salesStopDelay')}
            />
          </Form.Item>
        </Descriptions.Item>

        <Descriptions.Item
          label={
            <div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <span>Закрытие возврата</span>
                <Tooltip title="Целое отрицательное число">
                  <QuestionCircleOutlined />
                </Tooltip>
              </div>
              <div>
                <small>Количество минут до начала отправления</small>
              </div>
            </div>
          }
          labelStyle={{ width: '1%', whiteSpace: 'nowrap' }}
        >
          <Form.Item name="refundStopDelay" rules={requiredRules} noStyle>
            <FormInputRelativeDate
              relativeDateFieldName="startTime"
              status={errorFieldsStatus.getFieldStatus('refundStopDelay')}
            />
          </Form.Item>
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
});
